import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { OnboardTeacherBody } from "@shared-kernel/application/ports/shared/shared-repository";

export const onboardTeacher = createAsyncThunk<void, OnboardTeacherBody, { extra: Partial<Dependencies> }>(
  "users/onboardTeacher",
  async (body, { extra: { sharedRepository } }) => {
    return sharedRepository!.onboardTeacher(body);
  },
);
